<template>
  <v-btn class="mx-2 action-button-padding"
  :block="$vuetify.breakpoint.xsOnly"
  depressed
  color="primary"
  @click="archiveJob(jobId, 6)" >Archive</v-btn>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import { formatDate } from '@/components/Mixins/formatDate'

export default {
  name: 'ArchiveJobButton',
  props: {
    jobId: {
      type: String,
      required: true
    },
    listId: {
      type: Number,
      required: true
    }
  },
  mixins: [formatDate],
  data () {
    return {
      group: this.$store.getters.user.group
    }
  },
  methods: {
    async archiveJob (jobId, newListId) {
      console.log('jobId ', jobId)
      console.log('newListId ', newListId)
      const listId = this.listId
      const archiveDate = this.formatDateToISO(new Date())
      await firebase.database().ref(`lists/${this.group}/list${listId}/${jobId}`).update({
        archived_date: archiveDate,
        archived_from: listId
      })

      this.$store.dispatch('moveJob', { jobId: jobId, oldList: listId, newList: newListId })
      // emit job deleted
      this.$emit('job-moved')
    }
  }
}
</script>
